import { ReviewAndConfirmPage } from './ReviewAndConfirmPage';
import { WorkDetailsPage } from './WorkDetailsPage';

export * from './CreateOnsiteInterviewPage';
export * from './Types';

export const CreateOnsiteInterviewSubPages = {
  ReviewAndConfirmPage,
  WorkDetailsPage,
};
